<template>
	<v-step :steps="steps" v-model="step" @step="changeStep($event)" >
		<template slot="content-1">
			<b-row class="my-3">
				<b-col sm="6">
					<b-form-select v-model="brand" :options="brands" >
						<template slot="first">
							<option :value="null" disabled>Marca</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col sm="6">
					<b-form-select v-model="model" :options="models" >
						<template slot="first">
							<option :value="null" disabled>Modelo (Opcional)</option>
						</template>
					</b-form-select>
				</b-col>
			</b-row>
			<b-row class="my-3">
				<b-col sm="6">
					<b-form-select v-model="searchTime" :options="searchTimes" >
						<template slot="first">
							<option :value="null" disabled>Tiempo Búsqueda</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col sm="6">
					<b-form-select v-model="carType" :options="carTypes" >
						<template slot="first">
							<option :value="null" disabled>Tipo</option>
						</template>
					</b-form-select>
				</b-col>
			</b-row>
			<b-row class="my-3">
				<b-col sm="12">
					<label for="">Año</label>
				</b-col>
				<b-col sm="6">
					<b-form-select v-model="yearFrom" :options="years" >
						<template slot="first">
							<option :value="null" disabled>Desde</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col sm="6">
					<b-form-select v-model="yearTo" :options="years" >
						<template slot="first">
							<option :value="null" disabled>Hasta</option>
						</template>
					</b-form-select>
				</b-col>
			</b-row>
		</template>
		<template slot="content-2">
			<b-row class="my-3">
				<b-col sm="6">
					<b-form-input type="text" v-model="interested.rut" placeholder="RUT" autocomplete="off"></b-form-input>
				</b-col>
				<b-col sm="6">
					<b-form-input type="text" v-model="interested.name" placeholder="Nombre" autocomplete="off" ></b-form-input>
				</b-col>
			</b-row>
			<b-row class="my-3">
				<b-col sm="6">
					<b-form-input type="text" v-model="interested.lastname" placeholder="Apellido Paterno" autocomplete="off" ></b-form-input>
				</b-col>
				<b-col sm="6">
					<b-form-input type="text" v-model="interested.lastname2" placeholder="Apellido Materno" autocomplete="off"></b-form-input>
				</b-col>
			</b-row>
			<b-row class="my-3">
				<b-col sm="6">
					<b-form-input type="text" v-model="interested.phone" placeholder="Celular" autocomplete="off"></b-form-input>
				</b-col>
				<b-col sm="6">
					<b-form-input type="text" v-model="interested.email" placeholder="Email" autocomplete="off"></b-form-input>
				</b-col>
			</b-row>
		</template>
	</v-step>
</template>

<script>
	import VStep from "../../../../components/v-step";
	export default {
		name: 'v-car-solicitude',
		components: {
			'v-step': VStep
		},
		props: {
		},
		data(){
			return{
				step: 1,
				steps: [
					{id: 1, title: "Datos de tu interés"},
					{id: 2, title: "Tus datos"}
				],
				brand: null,
				yearFrom: null,
				yearTo: null,
				searchTime: null,
				model: null,
				carType: null,
				interested: {
					name: null,
					rut: null,
					lastname: null,
					lastname2: null,
					phone: null,
					email: null
				},
				brands: [
					{ value: 1, text: "Chevrolet" },
					{ value: 2, text: "Ford" },
					{ value: 3, text: "Hyundai" },
					{ value: 4, text: "Kia" },
					{ value: 5, text: "Mazda" },
					{ value: 6, text: "Nissan" },
					{ value: 7, text: "Peugeot" },
					{ value: 8, text: "Suzuki" },
					{ value: 9, text: "Toyota" }
				],
				years: [
					{ value: 1, text: "2013" },
					{ value: 2, text: "2014" },
					{ value: 3, text: "2015" },
					{ value: 4, text: "2016" },
					{ value: 5, text: "2017" },
					{ value: 6, text: "2018" },
					{ value: 7, text: "2019" },
					{ value: 8, text: "2020" }
				],
				models: [
					{ value: 1, text: "UNO" },
					{ value: 2, text: "DOS" },
					{ value: 3, text: "TRES" },
					{ value: 4, text: "CUATRO" },
					{ value: 5, text: "CINCO" },
					{ value: 6, text: "SEIS" },
				],
				searchTimes: [
					{ value: 1, text: "1 Mes" },
					{ value: 2, text: "2 Meses" },
					{ value: 3, text: "3 Meses" },
					{ value: 4, text: "4 Meses" },
					{ value: 5, text: "5 Meses" },
					{ value: 6, text: "6 Meses" },
					{ value: 7, text: "7 Meses" },
				],
				carTypes: [
					{ value: 1, text: "CAMIONETA" },
					{ value: 2, text: "FURGON" },
					{ value: 3, text: "HATCHBACK" },
					{ value: 4, text: "MINIBUS" },
					{ value: 5, text: "MOTOS" },
					{ value: 6, text: "SEDAN" },
					{ value: 7, text: "STATION WAGON" },
					{ value: 8, text: "SUV/JEEP" }
				],
			}
		},
		methods: {
			changeStep(value) {
				this.step = value;
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>